/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export enum ReelEvent
{
    OnLanded = 0,
    OnStopped = 1,
    OnStarted = 2,
    OnAnticipation = 3,
    OffAnticipation = 4,
    OnBonus = 5,
    OffBonus = 6,
    OnReelMatch = 7,
    OffReelMatch = 8,
    OnStreak = 9,
    OnClear = 10,
    Custom = 11,
    OnStopping = 12,
    OnBounceStart = 13,
    OnBounceBounceUp = 14,
    OnResetSpinning = 15,
    OnLocked = 16,
    OffLocked = 17,
    OnEnabled = 18,
    OnDisabled = 19
}

let ccReelEvent: typeof ReelEvent = cc.Enum(ReelEvent);
let GetReelEventName: (ReelEvent) => string = (event: ReelEvent) =>
{
    let action: string = ReelEvent[event];

    if (event === ReelEvent.OnStreak || event === ReelEvent.OnClear)
    {
        return action ? `Streak.${action}` : null;
    }

    return action ? `Reel.${action}` : null;
};

export { ccReelEvent, GetReelEventName };
